var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNewCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1264_840)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 4.99422,
    fill: "#29185E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7791 33.7611L51.0101 33.7846V26.1685C51.0101 25.5049 50.4759 24.9707 49.8123 24.9707C49.1489 24.9707 48.6145 25.5049 48.6145 26.1685L48.638 33.7613H41.1978C40.5342 33.7613 40 34.2955 40 34.9591C40 35.6225 40.5342 36.1567 41.1978 36.1567H48.6262V43.7498C48.6262 44.4129 49.1604 44.9476 49.824 44.9476C50.4876 44.9476 51.0219 44.4129 51.0219 43.7498V36.157H58.7791C59.4427 36.157 59.9769 35.6223 59.9769 34.9591C59.9769 34.2953 59.4367 33.7611 58.7791 33.7611Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1264_840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 4.99422,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewCategory);
export default __webpack_public_path__ + "static/media/add-new-category.c67ae2be5835da24d458f82f96abd455.svg";
export { ForwardRef as ReactComponent };